/**
 * nativeStorage keys
 */
export const UUID_TYPE = "UUID_TYPE";
export const XI_CUSTOM_USER_ID = "XI_CUSTOM_USER_ID";
export const PERSIST_COOKIES = "PERSIST_COOKIES";
export const SERVICE_LIST = "SERVICE_LIST";
export const PAYMENT_PARAMS = "PAYMENT_PARAMS";
export const PURCHASED_LIST = "PURCHASED_LIST";
export const LOCALIZE_PRICE = "LOCALIZE_PRICE_CACHE";
export const PRICE_OFFER_MAP = "PRICE_OFFER_MAP";
export const VIP_VIDEO_CACHE = "VIP_VIDEO_CACHE";
export const APP_FLYER_INFO = "APP_FLYER_INFO";
export const LIMIT_COINS_CACHE = "LIMIT_COINS_CACHE";
export const INSTALLED_APP = "INSTALLED_APP";
export const SUPER_PAY_PARAMS = "SUPER_PAY_PARAMS";
export const USER_HIT_COUNTER_LOCAL_KEY = "USER_HIT_COUNTER_LOCAL_KEY";
export const USER_STATUS_LOCAL_KEY = "USER_STATUS_LOCAL_KEY";
export const HAS_USE_SP_PAY = "HAS_USE_SP_PAY";
export const FAILED_ORDER_LIST = "FAILED_ORDER_LIST";
export const IS_LIMITEDCOIN_INITIAL: string = "IS_LIMITEDCOIN_INITIAL";
export const LIMITEDCOIN_COUNT_TIMESTAMP: string =
  "LIMITEDCOIN_COUNT_TIMESTAMP";
export const LIMITEDCOIN_COUNT_TIMESTAMP_FLAG: string =
  "LIMITEDCOIN_COUNT_TIMESTAMP_FLAG";
export const LIMITEDCOIN_COUNT_DURATION: string = "LIMITEDCOIN_COUNT_DURATION";

export const BACK_UP_HAS_INSTALL = "BACK_UP_HAS_INSTALL";
export const FEATURE_HAS_INSTALL = "FEATURE_HAS_INSTALL";
export const HAS_SHOW_BA_WHEN_PAYMENT_SUCCESSFUL_CLOSE =
  "HAS_SHOW_BA_WHEN_PAYMENT_SUCCESSFUL_CLOSE";
export const HAS_SHOW_FA_WHEN_PAYMENT_SUCCESSFUL_CLOSE =
  "HAS_SHOW_FA_WHEN_PAYMENT_SUCCESSFUL_CLOSE";
export const HAS_SHOW_FREE_FOLLOW = "HAS_SHOW_FREE_FOLLOW";
export const HAS_ENTER_RECOMMEND = "HAS_ENTER_RECOMMEND_OFFER";
export const PERSIST_USER_HELPERS = "PERSIST_USER_HELPERS";
export const BACK_UP_HAS_ADD_COINS = "BACK_UP_HAS_ADD_COINS";
export const PINAD_CACHE = "PINAD_CACHE";
export const ACT_USERS_LIST = "ACT_USERS_LIST";
export const ACT_USERS_MAP = "ACT_USERS_MAP";

export const PRESISITE_APIIDS = "PRESISITE_APIIDS";
export const PRESISITE_MOBILE_CONFIG_TS = "PRESISITE_MOBILE_CONFIG_TS";
export const PRESISITE_ENCRYPTION_KEY_ID = "PRESISITE_ENCRYPTION_KEY_ID";
export const PRESISITE_ENCRYPTION_PUB_KEY = "PRESISITE_ENCRYPTION_PUB_KEY";
export const INS_API_MID = "INS_API_MID";
export const PRESISITE_INS_HEADER = "PRESISITE_INS_HEADER";
